export const exact = {
  oAuthFlowHelp: "Authorise my account"
};